import React from 'react';
import { Link } from "react-router-dom";
import { GUIDE_SVG, GIFT_SVG, RIGHT_SVG, REWARD_LIST_SVG } from '../staticTypes';
import { trackSharePop } from '../../Utils/blogs'




const Points = (props) => {
	const { points, email, visitorId } = props;
	const onFollowPage = () => {
		trackSharePop(email, visitorId, 'follow-page')
	}
	const onPointsLists = () => {
		trackSharePop(email, visitorId, 'points-page')
	}
	const onWaysPage = () => {
		trackSharePop(email, visitorId, 'convert-page')		
	}
	return (
		<div className="panel-card-container points-explainer-card-container">
			<div className="points-explainer-card">
				{
					points > -1 ? 
					<div className="points-top">
						<div className="text-left">{ points } points</div>
						<Link to="/rewards-list" onClick={onPointsLists}>
							{REWARD_LIST_SVG}	
						</Link>
					</div>
					:
					<div>
					<div className="heading mb-5 pt-2 text-center">Points</div>
					<div className="card-description text-center">
						Earn more Points for different actions, and turn those Points into awesome rewards!
					</div>
					</div>
				}
				

				<div className="card-list-container">
					<div className="card-list-item-container to-earn-rewards" to="/earn">
						<Link to="/earn" onClick = {onFollowPage}>
							<button className="card-list-item " aria-label="Ways to earn">
								<div className="card-list-item-content">

									{GUIDE_SVG}

									<div className="list-item-text-wrapper">
										<div className="list-item-title">Ways to earn</div>
									</div>
								</div>
								<div className="chevron right">
								{RIGHT_SVG}
								</div>
							</button>
						</Link>
						</div>
					<div className="card-list-item-container to-ways-rewards no-image">
						<Link to="/ways" onClick = {onWaysPage}>
							<button className="card-list-item " aria-label="Ways to redeem">
								<div className="card-list-item-content">
								{GIFT_SVG}
								<div className="list-item-text-wrapper">
										<div className="list-item-title">Ways to redeem</div>
									</div>
								</div>
								<div className="chevron right">
									{RIGHT_SVG}
								</div>

							</button>
						</Link>
					</div>
				</div>
			</div>
		</div>

	)
}

export default Points;